module.exports = __webpack_public_path__ + "static/media/news-ellis-logo.d13808d5.jpg";